module.exports = __webpack_public_path__ + "static/pants-size-a0fe5aaeb60300d794b2b8bf4154d4bd.jpg";